<template>
  <div id="footerjp">
    <div class="footer-main">
      <div class="footer-main-block footer-container">
        <!-- Logo -->
        <div class="footer-logo hidden-xs hidden-sm">
          <img src="@/assets/img/footer_logo.png" @click="GoTop()" />
        </div>

        <!-- Navigation Columns -->
        <div class="footer-nav-columns hidden-xs hidden-sm">
          <div class="nav-column">
            <div class="nav-title">
              <router-link to="/jp">ホーム</router-link>
            </div>
            <!-- <div class="nav-item">
              <router-link to="/jp/contactus">お問い合わせ</router-link>
            </div> -->
          </div>

          <div class="nav-column">
            <div class="nav-title">
              <router-link to="/jp/apartment">アパートメント</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/apartment?type=1"><span>base</span>PLUS</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/apartment?type=2"><span>base</span></router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/apartment?type=3"><span>base</span>LITE</router-link>
            </div>
          </div>

          <div class="nav-column">
            <div class="nav-title">
              <router-link to="/jp/trend">ニュース</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/trend">特集</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/trend">イベント</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/trend">予告</router-link>
            </div>
          </div>

          <div class="nav-column">
            <div class="nav-title">
              <router-link to="/jp/business">提携</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/checkin">サービス</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/aboutus"><span>base</span>について</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/jobchance">採用情報</router-link>
            </div>
          </div>

          <div class="nav-column">
            <div class="nav-title">
              <router-link to="/jp/esg">ESG</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/esg?type=1">環境</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/esg?type=2">社会</router-link>
            </div>
            <div class="nav-item">
              <router-link to="/jp/esg?type=3">ガバナンス</router-link>
            </div>
          </div>
        </div>

        <!-- QR Code -->
        <div class="footer-qrcode hidden-xs hidden-sm">
          <img src="@/assets/img/footer_icon_wechat_green.png" />
        </div>
        <!-- Mobile Version -->
        <div class="footer-mobile visible-xs visible-sm">
          <div class="mobile-qrcode">
            <img src="@/assets/img/footer_icon_wechat_green.png" />
            <div class="qrcode-text">スキャンして<span>base</span>の詳細情報</div>
          </div>

          <div class="mobile-phone-section">
            <div class="phone-number">400-700-6008</div>
          </div>

          <div class="mobile-social-icons">
            <div class="social-icon">
              <a href="javascript:void(0)" target="_blank">
                <img src="@/assets/img/footer_icon_7_black.png" />
              </a>
            </div>
            <div class="social-icon" @click="openWePop(require('@/assets/img/footer_wecode_4.jpg'), 4)">
              <img src="@/assets/img/footer_icon_8_black.png" />
            </div>
            <div class="social-icon">
              <a @click="copyMail('enquiry.base@base-china.com')">
                <img src="@/assets/img/footer_icon_2_black.png" />
              </a>
            </div>
            <div class="social-icon" @click="openWePop(require('@/assets/img/footer_wecode_2.jpg'), 1)">
              <img src="@/assets/img/footer_icon_3_black.png" />
            </div>
            <div class="social-icon">
              <a href="https://v.douyin.com/B8TwFC7/" target="_blank">
                <img src="@/assets/img/footer_icon_4_black.png" />
              </a>
            </div>
            <div class="social-icon">
              <a href="https://www.xiaohongshu.com/user/profile/5df89dbd0000000001004d64" target="_blank">
                <img src="@/assets/img/footer_icon_6_black.png" />
              </a>
            </div>
          </div>

          <div class="footer-logo-mobile">
            <img src="@/assets/img/footer_logo.png" @click="GoTop()" />
          </div>

          <div class="mobile-nav-grid">
            <!-- Column 1: ホーム -->
            <div class="mobile-nav-item">
              <router-link to="/jp">ホーム</router-link>
            </div>
            <!-- Column 2: アパートメント -->
            <div class="mobile-nav-item">
              <router-link to="/jp/apartment">アパートメント</router-link>
            </div>
            <!-- Column 3: ニュース -->
            <div class="mobile-nav-item">
              <router-link to="/jp/trend">ニュース</router-link>
            </div>
            <!-- Column 4: 提携 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/business">提携</router-link>
            </div>
            <!-- Column 5: ESG -->
            <div class="mobile-nav-item">
              <router-link to="/jp/esg">ESG</router-link>
            </div>

            <!-- Row 2 -->
            <!-- Column 1: お問い合わせ -->
            <div class="mobile-nav-item">
              <router-link to="/jp/contactus">お問い合わせ</router-link>
            </div>
            <!-- Column 2: basePLUS -->
            <div class="mobile-nav-item">
              <router-link to="/jp/apartment?type=1"><span>base</span>PLUS</router-link>
            </div>
            <!-- Column 3: 特集 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/trend">特集</router-link>
            </div>
            <!-- Column 4: サービス -->
            <div class="mobile-nav-item">
              <router-link to="/jp/checkin">サービス</router-link>
            </div>
            <!-- Column 5: 環境 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/esg?type=1">環境</router-link>
            </div>

            <!-- Row 3 -->
            <!-- Column 1: Empty -->
            <div class="mobile-nav-item"></div>
            <!-- Column 2: base -->
            <div class="mobile-nav-item">
              <router-link to="/jp/apartment?type=2"><span>base</span></router-link>
            </div>
            <!-- Column 3: イベント -->
            <div class="mobile-nav-item">
              <router-link to="/jp/trend">イベント</router-link>
            </div>
            <!-- Column 4: baseについて -->
            <div class="mobile-nav-item">
              <router-link to="/jp/aboutus"><span>base</span>について</router-link>
            </div>
            <!-- Column 5: 社会 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/esg?type=2">社会</router-link>
            </div>

            <!-- Row 4 -->
            <!-- Column 1: Empty -->
            <div class="mobile-nav-item"></div>
            <!-- Column 2: baseLITE -->
            <div class="mobile-nav-item">
              <router-link to="/jp/apartment?type=3"><span>base</span>LITE</router-link>
            </div>
            <!-- Column 3: 予告 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/trend">予告</router-link>
            </div>
            <!-- Column 4: 採用情報 -->
            <div class="mobile-nav-item">
              <router-link to="/jp/jobchance">採用情報</router-link>
            </div>
            <!-- Column 5: ガバナンス -->
            <div class="mobile-nav-item">
              <router-link to="/jp/esg?type=3">ガバナンス</router-link>
            </div>
          </div>
        </div>
        <!-- Mobile End -->
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-block footer-container">
        <div class="social-contact">
          <span class="contact-label">公式SNS:</span>
          <div class="social-icons">
            <div class="social-icon">
              <a href="javascript:void(0)" target="_blank">
                <img src="@/assets/img/footer_icon_7_black.png" />
              </a>
            </div>
            <div class="social-icon" @click="openWePop(require('@/assets/img/footer_wecode_4.jpg'), 4)">
              <img src="@/assets/img/footer_icon_8_black.png" />
            </div>
            <div class="social-icon">
              <a @click="copyMail('enquiry.base@base-china.com')">
                <img src="@/assets/img/footer_icon_2_black.png" />
              </a>
            </div>
            <div class="social-icon" @click="openWePop(require('@/assets/img/footer_wecode_2.jpg'), 1)">
              <img src="@/assets/img/footer_icon_3_black.png" />
            </div>
            <div class="social-icon">
              <a href="https://v.douyin.com/B8TwFC7/" target="_blank">
                <img src="@/assets/img/footer_icon_4_black.png" />
              </a>
            </div>
            <div class="social-icon">
              <a @click="openWePop(require('@/assets/img/footer_wecode_2.jpg'), 3)">
                <img src="@/assets/img/footer_icon_6_black.png" />
              </a>
            </div>
          </div>
        </div>

        <div class="contact-phone">
          <span class="phone-label">電話:</span>
          <a href="tel:400-700-6008" class="phone-number">400-700-6008</a>
        </div>
      </div>
    </div>

    <!-- Copyright Bar -->
    <div class="footer-jt">
      <div class="footer-jt-block footer-container">
        <div class="footer-jt-pic">
          <img src="@/assets/img/footer_jt_pic.png" />
        </div>
      </div>
      <div class="footer-icp footer-l-item"><a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备15052590号-1</a>
      </div>
    </div>
    <div v-show="isWecodePopShow" id="wecode-pop">
      <div class="bg">
        <div class="close-pop" @click="closeWeCodePop"><img src="@/assets/img/icon_close.png" /></div>
        <div class="bg-block">
          <img :src="tempwecodeurl" class="wecodeimg" />
          <div class="wecodeinfo" v-html="tempewcodeinfo"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footerjp",
  data() {
    return {
      isWecodePopShow: false,
      tempwecodeurl: '',
      tempewcodeinfo: ''
    };
  },
  methods: {
    openWePop(url, type) {
      switch (type) {
        case 1:
          this.tempewcodeinfo = '【WeChatでスキャン】<br />base公式アカウントをフォロー'
          break;
        case 2:
          this.tempewcodeinfo = '【Douyinアプリでスキャン】<br />base公式Douyinアカウントをフォロー'
          break;
        case 3:
          this.tempewcodeinfo = '【Xiaohongshuアプリでスキャン】<br />base公式Xiaohongshuアカウントをフォロー'
          break;
        case 4:
          this.tempewcodeinfo = '【Instagramで読み取り】<br />BASE公式Instagramをフォロー'
          break;
      }
      this.tempwecodeurl = url;
      this.isWecodePopShow = true;
    },

    closeWeCodePop() {
      this.isWecodePopShow = false;
      this.tempwecodeurl = '';
      this.tempewcodeinfo = '';
    },

    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    copyMail(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      //this.$message.success('メールアドレスをコピーしました');
      alert('メールアドレスをコピーしました');
    }
  },
};
</script>
<style lang="scss" scoped>
a {
  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
}

#footerjp {
  width: 100%;
  height: 100%;
  color: #272727;
  background: #fff;
  overflow: hidden;
  font-size: 14px;

  .footer-container {
    width: 1200px;
    margin: 0 auto;
  }

  .footer-main {
    background: #fff;
    border-top: 1px solid #d8d8d8;

    .footer-main-block {
      padding: 40px 0 30px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .footer-logo {
        width: 120px;
        flex-shrink: 0;
        cursor: pointer;
        margin-right: 40px;

        img {
          width: 100%;
        }
      }

      .footer-nav-columns {
        display: flex;
        flex: 1;
        justify-content: space-between;
        max-width: 800px;

        .nav-column {
          flex: 1;
          min-width: 120px;

          .nav-title {
            font-size: 14px;
            font-weight: bold;
            color: #272727;
            margin-bottom: 12px;

            span {
              font-family: $FM6;
            }

            a {
              color: #272727;
              transition: color 0.3s;
              font-weight: bold;

              span {
                font-family: $FM6;
              }

              &:hover {
                color: #3C5896;
              }
            }
          }

          .nav-item {
            margin-bottom: 8px;
            font-size: 14px;
            line-height: 1.6;

            a {
              color: #272727;
              transition: color 0.3s;

              span {
                font-family: $FM6;
              }

              &:hover {
                color: #3C5896;
              }
            }
          }
        }
      }

      .footer-qrcode {
        width: 120px;
        flex-shrink: 0;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }

      .footer-mobile {
        display: none;
      }
    }
  }

  .footer-bottom {
    background: #fff;
    border-top: 1px solid #e5e5e5;

    .footer-bottom-block {
      padding: 20px 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 60px;

      .social-contact {
        display: flex;
        align-items: center;
        gap: 15px;

        .contact-label {
          font-size: 14px;
          color: #272727;
          white-space: nowrap;
        }

        .social-icons {
          display: flex;
          align-items: center;
          gap: 12px;

          .social-icon {
            cursor: pointer;
            transition: opacity 0.3s;

            &:hover {
              opacity: 0.7;
            }

            img {
              width: 24px;
              height: 24px;
            }

            a {
              display: block;
            }
          }
        }
      }

      .contact-phone {
        display: flex;
        align-items: center;
        gap: 10px;

        .phone-label {
          font-size: 14px;
          color: #272727;
          white-space: nowrap;
        }

        .phone-number {
          font-size: 18px;
          font-weight: bold;
          color: #272727;
          text-decoration: none;

          &:hover {
            color: #3C5896;
          }
        }
      }
    }
  }

  .footer-jt {
    background: rgba(5, 24, 38, 0.98);
    display: flex;
    align-items: center;

    .footer-jt-block {
      flex: 1;
      padding: 17px 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .footer-jt-pic {
        width: 180px;

        img {
          width: 100%;
        }
      }
    }

    .footer-icp {
      font-size: 12px;
      font-weight: normal;
      color: #8D8D8D;
      padding-right: 32px;

      a {
        color: #8D8D8D;
      }
    }
  }

  #wecode-pop {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1005;
    background: rgba(0, 0, 0, 0.8);


    .bg {
      width: 400px;
      height: 450px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      .close-pop {
        width: 25px;
        height: 25px;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
        z-index: 100;

        img {
          width: 100%;
        }
      }

      .bg-block {
        width: 400px;
        height: 420px;
        border-radius: 15px;
        box-sizing: border-box;
        background: #fff;
        position: absolute;
        bottom: 0;
        left: 0;

        .wecodeimg {
          width: 250px;
          height: 250px;
          margin: 60px auto 10px;
        }

        .name {
          font-family: SourceHanSansCN-Bold;
          font-size: 16px;
          font-weight: bold;
          color: #3D3D3D;
          text-align: center;
        }

        .wecodeinfo {
          text-align: center;
          font-family: SourceHanSansCN-Regular;
          font-size: 14px;
          font-weight: normal;
          color: #3D3D3D;
        }
      }
    }
  }
}


@media screen and (min-width: 768px) and (max-width: 996px) {
  #footerjp {
    .footer-container {
      width: 96%;
      margin: 0 auto;
    }

    .footer-main {
      .footer-main-block {
        padding: 30px 0;
        flex-direction: column;
        align-items: center;

        .footer-logo {
          display: none;
        }

        .footer-nav-columns {
          display: none;
        }

        .footer-qrcode {
          display: none;
        }

        .footer-mobile {
          display: block;
          width: 100%;
          text-align: center;

          .mobile-qrcode {
            margin-bottom: 20px;

            img {
              width: 120px;
              height: 120px;
              margin: 0 auto 10px;
              display: block;
            }

            .qrcode-text {
              font-size: 12px;
              color: #272727;

              span {
                font-family: $FM6;
              }
            }
          }

          .mobile-phone-section {
            margin-bottom: 20px;

            .phone-number {
              font-size: 18px;
              font-weight: bold;
              color: #272727;
            }
          }

          .mobile-social-icons {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 15px;
            margin-bottom: 20px;
            flex-wrap: wrap;

            .social-icon {
              cursor: pointer;
              transition: opacity 0.3s;

              &:hover {
                opacity: 0.7;
              }

              img {
                width: 40px;
                height: 40px;
              }

              a {
                display: block;
              }
            }
          }

          .footer-logo-mobile {
            width: 80px;
            margin: 0 auto 20px;
            cursor: pointer;

            img {
              width: 100%;
            }
          }

          .mobile-nav-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 15px;
            text-align: center;

            .mobile-nav-item {
              font-size: 12px;

              a {
                color: #272727;

                span {
                  font-family: $FM6;
                }

                &:hover {
                  color: #3C5896;
                }
              }
            }
          }
        }
      }
    }

    .footer-bottom {
      display: none;
    }
  }
}


@media screen and (min-width: 997px) and (max-width: 1199px) {
  #footerjp {
    .footer-container {
      width: 970px;
      margin: 0 auto;
    }

    .footer-main {
      .footer-main-block {
        .footer-logo {
          width: 100px;
          margin-right: 30px;
        }

        .footer-nav-columns {
          max-width: 700px;

          .nav-column {
            min-width: 100px;
          }
        }

        .footer-qrcode {
          width: 100px;
        }
      }
    }

    .footer-bottom {
      .footer-bottom-block {
        flex-wrap: wrap;
        gap: 20px;

        .social-contact {
          flex: 1;
          min-width: 300px;

          .contact-label {
            display: none;
          }

          .social-icons {
            gap: 15px;
          }
        }

        .contact-phone {
          .phone-label {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {}


@media only screen and (max-width: 768px) {
  #footerjp {
    .footer-container {
      width: 96%;
      margin: 0 auto;
    }

    .footer-main {
      .footer-main-block {
        padding: 30px 0;

        .footer-logo {
          display: none;
        }

        .footer-nav-columns {
          display: none;
        }

        .footer-qrcode {
          display: none;
        }

        .footer-mobile {
          display: block;
          width: 100%;
          text-align: center;

          .mobile-qrcode {
            text-align: center;
            margin-bottom: 20px;

            img {
              width: 120px;
              height: 120px;
              margin: 0 auto 10px;
              display: block;
            }

            .qrcode-text {
              font-size: 12px;
              color: #272727;

              span {
                font-family: $FM6;
              }
            }
          }

          .mobile-phone-section {
            margin-bottom: 15px;

            .phone-number {
              font-size: 18px;
              font-weight: bold;
              color: #272727;
            }
          }

          .mobile-social-icons {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            gap: 15px;
            margin-bottom: 20px;
            flex-wrap: wrap;

            .social-icon {
              cursor: pointer;
              transition: opacity 0.3s;

              &:hover {
                opacity: 0.7;
              }

              img {
                width: 40px;
                height: 40px;
              }

              a {
                display: block;
              }
            }
          }

          .footer-logo-mobile {
            width: 80px;
            margin: 0 auto 20px;
            cursor: pointer;

            img {
              width: 100%;
            }
          }

          .mobile-nav-grid {
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            gap: 15px;
            text-align: center;

            .mobile-nav-item {
              font-size: 12px;

              a {
                color: #272727;

                span {
                  font-family: $FM6;
                }

                &:hover {
                  color: #3C5896;
                }
              }
            }
          }
        }
      }
    }

    .footer-bottom {
      display: none;
    }

    .footer-jt {
      .footer-jt-block {
        .footer-jt-pic {
          width: 140px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footerjp.vue